import {Button, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface GetInTouchButtonProps {
  onClick: () => void;
}

/**
 * Page-header trigger for the "Get in touch" feedback modal.
 *
 * Shared by the Models, Predictions, and Batches headers so all three get identical chrome.
 */
export default function GetInTouchButton({onClick}: GetInTouchButtonProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Button
      classNames={{root: classes.root}}
      leftIcon={<BenchlingIcon icon="comment-outline" />}
      onClick={onClick}
      variant="ghost"
    >
      Get in touch
    </Button>
  );
}

const useStyles = createStyles((theme) => ({
  // `ghost` gives the white/neutral fill and hover; design pairs it with a gray outline rather than
  // the blue one `secondary` draws, so the border is the only delta.
  root: {
    border: `1px solid ${theme.colors.gray[3]}`,
    color: theme.colors.gray[9],
    fontSize: theme.fontSizes.sm,
  },
}));
